 <template>

   <!--新版本评论弹窗8-21-->
   <div class="alert-box comments-alert-new" :class="cdCls">
     <p class="mask" v-on:click="closeFun(false)"></p>
     <div class="alert-con">
       <img v-on:click="closeFun(false)" class="icon-close" src="../assets/icon-close.png" />
       <div class="alert-info border-box">

         <div class="video-info-img-box" v-if="page!='maptour'">
           <p class="gray-mask"></p>
           <p class="video-info-img border-box">
             <img class="img" :src="bagInfo.guideheadimg2?bagInfo.guideheadimg2:bagInfo.guideheadimg"  />
           </p>
         </div>

         <p class="comments-alert-title">打个分吧</p>
         <div class="comments-alert-level">
           <span>星级评价：</span>
           <template v-for="(item,index) in [2,4,6,8,10]">
             <img @click="starSelect(index)" v-if="score>=item" src="../assets/icon_com.png"/>
             <img @click="starSelect(index)" v-else  src="../assets/start_nor.png" />
           </template>
           <span class="comments-level-text">{{startText}}</span>
         </div>

         <p class="comments-write-title">说说感受：</p>
         <textarea class="comments-textarea border-box" v-model="commentInfo" placeholder="说点什么吧"></textarea>

         <div class="upload-box clearfix">

             <div class="add-img" >
               <p class="font24 cor9 lineH60">图片(最多6张，还可上传<span v-text="6-imgList.length"></span>张)</p>
               <ul class="fl img-list clearfix">
                 <li v-for="(url,index) in imgList" v-show="imgList.length">
                   <img class="icon-delete" src="../assets/icon_close2.png" @click.stop="delImg(index)"/>
                   <img class="img-list-pic" :src="url.file.src">
                 </li>
                 <li>
                   <input @change="fileChange($event)" type="file" id="upload_file" multiple style="display: none"/>
                   <img @click="chooseType" class="fl add-img-btn" src="../assets/add-image.png" />
                 </li>
               </ul>
           </div>
         </div>
         <button @click="sendComment" class="btn-send">提交</button>
       </div>
     </div>
   </div>

</template>

<script>

import { mapState, mapMutations } from 'vuex'
import {setStore, getStore, removeStore} from '@/config/mUtils'
import {uploadPic,uploadCom,uploadComMap} from '@/utils/wechat'
import Exif from 'exif-js'

import D from '@/wc-messagebox'
import Vue from 'vue'
Vue.use(D)

export default {
    data(){
        return{
            userInfo: '',
            commentClose:0,//弹窗关闭
            imgList: [],
            imgSrcs: [],
            size: 0,
            limit:6, //限制图片上传的数量
            tempImgs:[],
            score:10,//评论评分
            startText:'超赞',//评论等级
            commentInfo:'',//评论文字内容
            isSuccess: false, //评论是否提交
        }
    },
    created(){
      this.userInfo = getStore("userInfo");
    },
    props: ['bagInfo','bagtype','page','spotid','shopid'],
    computed: {
      cdCls() {
        var cla
        if(this.bagtype == 'sm'){
          cla = 'sm'
        }
        return cla
      }
    },
    methods: {
      closeFun:function(success){
        if(success){
          this.$emit('child-Comment',{commentShow: this.commentClose, success: true});
        }else {
          this.$emit('child-Comment',{commentShow: this.commentClose, success: false});
        }
      },

      //上传图片
      chooseType(){
        document.getElementById('upload_file').click();
      },
      fileChange(el){
        if (!el.target.files[0].size) return;
        this.fileList(el.target);
        el.target.value = ''
      },
      fileList(fileList){
        let files = fileList.files;
        for (let i = 0; i < files.length; i++) {
          //判断是否为文件夹
          if (files[i].type != '') {
            this.fileAdd(files[i]);
          } else {
            //文件夹处理
            this.folders(fileList.items[i]);
          }
        }
      },
      //文件夹处理
      folders(files){
        let self = this;
        //判断是否为原生file
        if (files.kind) {
          files = files.webkitGetAsEntry();
        }
        files.createReader().readEntries(function (file) {
          for (let i = 0; i < file.length; i++) {
            if (file[i].isFile) {
              self.foldersAdd(file[i]);
            } else {
              self.folders(file[i]);
            }
          }
        });
      },
      foldersAdd(entry){
        let self = this;
        entry.file(function (file) {
          self.fileAdd(file)
        })
      },
      fileAdd(file){
        let self = this;
        let Orientation;
        Exif.getData(file, function(){
          Orientation = Exif.getTag(this, 'Orientation');
        });

        if (this.limit !== undefined) this.limit--;
        if (this.limit !== undefined && this.limit < 0) return;
        //总大小
        this.size = this.size + file.size;
        //判断是否为图片文件
        if (file.type.indexOf('image') == -1) {
          this.$toast("请选择图片文件",{ location: ''})
        } else {
          let reader = new FileReader();
          let image = new Image();
          reader.readAsDataURL(file);
          reader.onload = function () {
            file.src = this.result;

            //判断图片是否小于150K,是就直接上传，反之压缩图片
            image.src = file.src;
            if(this.result.length <= (150 * 1024)){
              image.onload = function () {
                file.width = image.width;
                file.height = image.height;
                self.imgList.push({file});
                self.imgSrcs[self.imgSrcs.length] = image.src;
              };
            }else {
              image.onload = function () {
                file.width = image.width;
                file.height = image.height;
                self.imgList.push({file});
                let data = self.compress(image,Orientation);
                self.imgSrcs[self.imgSrcs.length] = data;
              };
            }
          }
        }
      },
      delImg(index){
        this.size = this.size - this.imgList[index].file.size;//总大小
        this.imgList.splice(index, 1);
        this.imgSrcs.splice(index, 1);
        if (this.limit !== undefined) this.limit = 6 - this.imgList.length;
      },
      rotateImg (img, direction,canvas) {
        //最小与最大旋转方向，图片旋转4次后回到原方向
        const min_step = 0;
        const max_step = 3;
        if (img == null)return;
        //img的高度和宽度不能在img元素隐藏后获取，否则会出错
        let height = img.height;
        let width = img.width;
        let step = 2;
        if (step == null) {
          step = min_step;
        }
        if (direction == 'right') {
          step++;
          //旋转到原位置，即超过最大值
          step > max_step && (step = min_step);
        } else {
          step--;
          step < min_step && (step = max_step);
        }
        //旋转角度以弧度值为参数
        let degree = step * 90 * Math.PI / 180;
        let ctx = canvas.getContext('2d');
        switch (step) {
          case 0:
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0);
            break;
          case 1:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, 0, -height);
            break;
          case 2:
            canvas.width = width;
            canvas.height = height;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, -height);
            break;
          case 3:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, 0);
            break;
        }
      },
      compress(img,Orientation) {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext('2d');
        //瓦片canvas
        let tCanvas = document.createElement("canvas");
        let tctx = tCanvas.getContext("2d");
        let initSize = img.src.length;
        let width = img.width;
        let height = img.height;
        //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
        let ratio;
        if ((ratio = width * height / 4000000) > 1) {
          ratio = Math.sqrt(ratio);
          width /= ratio;
          height /= ratio;
        } else {
          ratio = 1;
        }
        canvas.width = width;
        canvas.height = height;
        //        铺底色
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        //如果图片像素大于100万则使用瓦片绘制
        let count;
        if ((count = width * height / 1000000) > 1) {
          count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
          //            计算每块瓦片的宽和高
          let nw = ~~(width / count);
          let nh = ~~(height / count);
          tCanvas.width = nw;
          tCanvas.height = nh;
          for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
              tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
              ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
            }
          }
        } else {
          ctx.drawImage(img, 0, 0, width, height);
        }
        //修复ios上传图片的时候 被旋转的问题
        if(Orientation != "" && Orientation != 1){
          switch(Orientation){
            case 6://需要顺时针（向左）90度旋转
              this.rotateImg(img,'left',canvas);
              break;
            case 8://需要逆时针（向右）90度旋转
              this.rotateImg(img,'right',canvas);
              break;
            case 3://需要180度旋转
              this.rotateImg(img,'right',canvas);//转两次
              this.rotateImg(img,'right',canvas);
              break;
          }
        }
        //进行最小压缩
        let ndata = canvas.toDataURL('image/jpeg', 0.2);
        tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
        return ndata;
      },

      //评分
      starSelect: function(index) {
        if(index<=4){
          if (index == 0) {
            this.startText= '糟糕'
          } else if (index == 1) {
            this.startText='不好'
          } else if (index == 2) {
            this.startText= '一般'
          } else if (index == 3) {
            this.startText= '厉害'
          } else if (index == 4) {
            this.startText= '超赞'
          }
        }
        this.score=(index + 1) * 2
      },

      //上传评论
      sendComment(){
        let self = this;
        if(this.isSuccess){
          return;
        }else {
          this.isSuccess = true;
          if(this.commentInfo=='' || this.commentInfo == null){
            this.$toast('请先输入内容');
            this.isSuccess = false;
          }else{
            this.$loading.show('提交评论中');
            if(this.imgSrcs.length > 0){
              uploadPic(this.imgSrcs,function(res){
                if(res.data.errcode == "00000"){
                  self.uploadEnd(res.data.data.data);
                }else {
                  self.$loading.hide();
                  this.isSuccess = false;
                  self.$toast('图片上传出错')
                }
              });
            }else {
              self.uploadEnd('');
            }
          }
        }

      },

      uploadEnd(imgs){
        let self = this;
        if(this.page == 'maptour'){
          let obj = {
            openid: this.userInfo.openid,
            spotid: this.spotid || '',
            shopid: this.shopid || '',
            info: this.commentInfo,
            type: this.spotid?0:1, //0景点 1景区
            score: this.score,
            imgurl: imgs.toString()
          };
          uploadComMap(obj,function(res){
            self.$loading.hide();
            self.isSuccess = false;
            if(res.data.errcode == "00000"){
              self.$toast('评论成功');
              self.score = 10;
              self.commentInfo = '';
              self.imgList = [];
              self.imgSrcs = [];
              self.closeFun(true);
            }else {
              self.$toast(res.data.errmsg);
            }
          })
        }else {
          uploadCom(this.bagInfo.id,this.commentInfo,this.score,imgs,function(res){
            self.$loading.hide();
            self.isSuccess = false;
            if(res.data.errcode == "00000"){
              self.$toast('评论成功');
              self.score = 10;
              self.commentInfo = '';
              self.imgList = [];
              self.imgSrcs = [];
              self.closeFun(true);
            }else {
              self.$toast(res.data.errmsg);
            }
          })
        }

      }

    },
}
</script>

<style scoped>

  @import '../style/alert';

  .comments-alert-new.sm .alert-con{ background: #fff url(../assets/sm-shade.png) repeat; }
  .comments-alert-new.sm .comments-textarea{ background: rgba(255,255,255,0); }
  .comments-alert-new.sm .btn-send{ background: #796042; }

</style>



// WEBPACK FOOTER //
// src/components/AlertComment.vue